import storage from '@/libs/storage';
import HllUI from '@/libs/hll-m-ui';
import { getUrlParam } from '@/utils';
import { callApp } from './index';
import {
  isHllApp,
  isWxMiniProgram,
  isWeixinBrowser,
  isXlUserApp,
  isDouyinMiniProgram
} from './judgeEnv';
import Chain from './Chain';

const WX_LOCATION_STATUS = {
  SUCCESS: 'SUCCESS',
  FAIL: 'FAIL',
  CANCEL: 'CANCEL'
};

const DY_LOCATION_STATUS = {
  SUCCESS: 'SUCCESS',
  FAIL: 'FAIL'
};

/**
 * @description 获取微信定位
 */
function getWxLocation() {
  return new Promise(resolve => {
    wx.ready(() => {
      wx.getLocation({
        // type: 'gcj02',
        type: 'wgs84',
        success(data) {
          console.log(data, 'wx respon');
          let { latitude, longitude, accuracy } = data;
          resolve({
            latitude,
            longitude,
            accuracy,
            geo_type: 'WGS84',
            status: WX_LOCATION_STATUS.SUCCESS
          });
        },
        fail(err) {
          console.log('微信定位失败', JSON.stringify(err));
          resolve({
            status: WX_LOCATION_STATUS.FAIL
          });
        },
        cancel(err) {
          console.log('微信定位用户拒绝', JSON.stringify(err));
          resolve({ status: WX_LOCATION_STATUS.CANCEL });
        }
      });
    });
  });
}

/**
 * @description 获取抖音定位
 */
function getDouYinLocation() {
  return new Promise((resolve, reject) => {
    if (!tt) {
      reject('sdk not ready');
      return;
    }
    tt.miniProgram.getLocation({
      type: 'wgs84',
      success(data) {
        console.log(data, 'dy response');
        let { latitude, longitude, accuracy } = data;
        resolve({
          latitude,
          longitude,
          accuracy,
          geo_type: 'WGS84',
          status: DY_LOCATION_STATUS.SUCCESS
        });
      },
      fail(err) {
        console.log('抖音定位失败', JSON.stringify(err));
        resolve({
          status: DY_LOCATION_STATUS.FAIL
        });
      }
    });
  });
}

/**
 * @description 获取百度定位
 */
function getBdLocation() {
  /* eslint-disable */
  return new Promise(res => {
    try {
      var map = new BMap.Map('allmap');
      var point = new BMap.Point(116.381398, 39.897445);
      map.centerAndZoom(point, 12);
      var geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(function(r) {
        if (this.getStatus() == BMAP_STATUS_SUCCESS) {
          var mk = new BMap.Marker(r.point);
          map.addOverlay(mk);
          map.panTo(r.point);
          res(
            r.point
              ? {
                  longitude: r.point.lng || r.latitude,
                  latitude: r.point.lat || r.longitude,
                  accuracy: r.accuracy,
                  geo_type: 'BD09'
                }
              : {}
          );
        } else {
          res({ latitude: '', longitude: '' });
        }
      });
    } catch (err) {
      console.error(err);
      res({ latitude: '', longitude: '' });
    }
  });
}

/**
 * @description 获取app定位
 */
function getAppLocation() {
  return new Promise(res => {
    window.locSuccess = (...arg) => {
      let obj = {};
      let reg = /^{.*}$/g;
      if (arg && arg[0] && typeof arg[0] == 'string') {
        if (reg.test(arg[0])) {
          obj = arg[0] ? JSON.parse(arg[0]) : {};
        } else {
          obj.lat = arg[0].split('|')[0];
          obj.lon = arg[0].split('|')[1];
        }
        console.log(arg, 'app定位');
        res(
          arg[0]
            ? { longitude: obj.lon, latitude: obj.lat, geo_type: 'WGS84' }
            : {}
        );
      } else {
        res({});
      }
    };
    var args = JSON.stringify({
      action: 'position',
      callback: 'locSuccess'
    });
    callApp(args);
  });
}

/**
 * @description 获取高德定位
 */
async function getAmapLocation() {
  /* eslint-disable */
  let city = await new Promise((res, rej) => {
    var map = new AMap.Map('container', {
      resizeEnable: true
    });
    AMap.plugin('AMap.Geolocation', function() {
      var geolocation = new AMap.Geolocation({
        enableHighAccuracy: true, //是否使用高精度定位，默认:true
        timeout: 5000, //超过10秒后停止定位，默认：5s
        buttonPosition: 'RB', //定位按钮的停靠位置
        buttonOffset: new AMap.Pixel(10, 20), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
        zoomToAccuracy: true //定位成功后是否自动调整地图视野到定位点
      });
      map.addControl(geolocation);
      geolocation.getCurrentPosition(function(status, result) {
        if (status == 'complete') {
          console.log(result, 'amap response');
          res(
            result.position
              ? {
                  longitude: result.position.lng,
                  latitude: result.position.lat,
                  accuracy: result.accuracy,
                  geo_type: 'GCJ-02'
                }
              : {}
          );
        } else {
          res({});
        }
      });
    });
  });
  return new Promise(resolve => {
    resolve(city);
  });
}

async function getWebInfoChain() {
  const result  = await preResolveLocation()

  const {latitude =null, longitude =null} = result || {}
  if(latitude && longitude) {
    return {
      ret :true,
      meta: result,
      origin: 'preResolveLocation'
    }
  }

  return {ret :false}
}

async function getAppLocationChain() {
  const result  = await getAppLocation()

  return {
    ret :true,
    meta: result,
    origin: 'getAppLocation'
  }
}


async function getAppInnerLocation() {
  const locationListChain = [getWebInfoChain, getAppLocationChain]
  const chain =  new Chain({ list:locationListChain })

  let canHandle = false;
  let nextAction = null;
  let fuse = false; // 是否中断
  let finalResult = null;
  let taskName = null;
  while (!canHandle && !fuse && (nextAction = chain.next())) {
    try {
      const startTime = Date.now();
      const { ret, interrupt, meta, origin } = await nextAction();
      const elapsed = (Date.now() - startTime) / 1000; // 秒

      canHandle = ret;
      fuse = !!interrupt;
      finalResult = meta;
      taskName = origin;

      console.log('@定位-耗时', `${{
        taskName,
        elapsed: `${elapsed}秒`,
        curAction: nextAction.toString(),
      }}`)
    } catch (e) {
      console.log('@定位-失败', e, {
        taskName,
        nextAction: nextAction.toString(),
        func: 'fetchLocationCommandHandler',
      })
    }
  }

  return finalResult
}



/**
 * @param {boolean} isHideLoading: 是否不加载loading动画
 * @warn 一个页面同时多次请求位置，只能请求获取一次位置
 * @description 获取各端定位坐标，坐标缓存本地10min
 */
async function getLocation(isHideLoading, skipWechat = false) {
  let position = {};
  if (!isHideLoading) HllUI.$hll.showLoading(0);
  if (!storage.get('act_position')) {
    if (
      ((getUrlParam('token') || getUrlParam('_token')) &&
        (getUrlParam('longitude') && getUrlParam('latitude'))) ||
      (getUrlParam('lat') && getUrlParam('lon'))
    ) {
      position.longitude = getUrlParam('longitude') || getUrlParam('lon');
      position.latitude = getUrlParam('latitude') || getUrlParam('lat');
      position.geo_type = 'GCJ-02';
      console.log('app url location');
    }
    if (!position.latitude || !position.longitude) {
      if (isHllApp() && !isXlUserApp()) {
        position = await getAppInnerLocation();
        console.log('app location');
      } else if (isWxMiniProgram() || isWeixinBrowser()) {
        if (!skipWechat) {
          const {status, ...rest } = await getWxLocation();
          if (status === WX_LOCATION_STATUS.SUCCESS) {
            position = rest
          } else if (status === WX_LOCATION_STATUS.CANCEL) {
            // 不走后面的百度/高德
            console.log('用户主动拒绝微信定位授权');
            return Promise.resolve({})
          }
          console.log('wx location');
        } else {
          console.log('跨过微信定位');
        }
      } else if (isDouyinMiniProgram()) {
        const { status, ...rest } = await getDouYinLocation();
        if (status === DY_LOCATION_STATUS.FAIL) {
          return Promise.resolve({})
        }
        position = rest
      }
    }
    if ((!position.latitude || !position.longitude) && !isWxMiniProgram()) {
      position = await getBdLocation();
      console.log('bd location');
    }
    if (!position.latitude || !position.longitude) {
      console.log('getAmapLocation');
      position = await getAmapLocation();
      console.log('amap location');
    }
    if (!isHideLoading) HllUI.$hll.hideLoading();
    storage.set('act_position', position, 10 * 60 * 1000);
  } else {
    if (!isHideLoading) HllUI.$hll.hideLoading();
    position = storage.get('act_position');
  }

  console.log(position, 'position++++++++');
  return new Promise(resolve => {
    resolve(position instanceof Object ? position : {longitude: 0,
      latitude:0});
  });
}

export {
  getLocation,
  getAmapLocation,
  getAppLocation,
  getBdLocation,
  getWxLocation,
  getDouYinLocation
};
